class Venue {
  constructor(data) {
    data = data || {};

    this.city              = data.city || null;
    this.clients_id        = data.clients_id || null;
    this.clients_name      = data.clients_name || null;
    this.id                = data.id || null;
    this.markets_id        = data.markets_id || null;
    this.markets_name      = data.markets_name || null;
    this.state             = data.state || null;
    this.street_address1   = data.street_address1 || null;
    this.venue_name        = data.venue_name || null;
    this.venues_id         = data.venues_id || null;
    this.venues_types_id   = data.venues_types_id || null;
    this.venues_types_name = data.venues_types_name || null;
    this.vpid              = data.vpid || null;
    this.zip               = data.zip || null;
  }
}

export default Venue;
